import { FunctionComponent, useRef, useState } from "react";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import { Language, MainMenuItem, PageState } from "../types/index.js";
import { onTransitionEnd } from "../utils/utils.js";
import LeftOverlayNavItemTopLevel from "./LeftOverlayNavItemTopLevel.js";
import LeftOverlaySubmenu from "./LeftOverlaySubmenu.js";

interface Props {
  isPreview: boolean;
  pages: PageState;
  languageId: Language;
  fallbackLanguageId: Language | undefined;
  activePagePath: string[];
  menuItems: MainMenuItem[];
}

const LeftOverlayNav: FunctionComponent<Props> = ({
  isPreview,
  pages,
  languageId,
  fallbackLanguageId,
  activePagePath,
  menuItems,
}) => {
  const openIndexRef = useRef(0);
  const [isOpen, setIsOpen] = useState(false);

  const currentMenuItem = menuItems[openIndexRef.current];

  return (
    <div className="LeftOverlayNav">
      <SwitchTransition>
        <CSSTransition
          key={String(isOpen)}
          addEndListener={onTransitionEnd}
          classNames="LeftOverlayNav__MenuContainer"
        >
          <div className="LeftOverlayNav__MenuContainer">
            {!isOpen && (
              <div className="LeftOverlayNav__MainMenu">
                <ul className="MainMenu__List MainMenu__ListLevel0">
                  {menuItems.map((menuItem, index) => (
                    <LeftOverlayNavItemTopLevel
                      key={menuItem.id}
                      activePagePath={activePagePath}
                      currentMenuItem={menuItem}
                      fallbackLanguageId={fallbackLanguageId}
                      isPreview={isPreview}
                      languageId={languageId}
                      pages={pages}
                      parentId={menuItem.id}
                      onOpen={() => {
                        openIndexRef.current = index;
                        setIsOpen(true);
                      }}
                    />
                  ))}
                </ul>
              </div>
            )}

            {isOpen && currentMenuItem && (
              <LeftOverlaySubmenu
                activePagePath={activePagePath}
                fallbackLanguageId={fallbackLanguageId}
                isPreview={isPreview}
                languageId={languageId}
                currentMenuItem={currentMenuItem}
                onClose={() => setIsOpen(false)}
                pages={pages}
              />
            )}
          </div>
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
};

export default LeftOverlayNav;
